import { Runtime, pipe, Option, These } from "fp";

import * as Data from "~/Data";
import * as Log from "~/Log";
import { Order } from "~/Order";
import { Time } from "~/Time";

import { Created } from "./Created";

export * from "./Created";

export type Event = Log.Event.Event & Partial<Created>;

export const order = (): Order<Event> => Order.fromCompare(compare);
export const compare: Order.Compare<Event> = (a, b) =>
  pipe(
    These.fromNullables(a.created, b.created),
    Option.fold(
      () => Time.Interval.compare(a, b),
      These.fold(
        ({ dateTime }) =>
          Time.Interval.compare({ interval: { start: { dateTime } } }, b),
        ({ dateTime }) =>
          Time.Interval.compare(a, { interval: { start: { dateTime } } }),
        Time.DateTime.compare
      )
    )
  );

export namespace Response {
  export const runtime = () =>
    Runtime.intersection([
      Log.Event.Response.runtime(),
      Created.Response.runtime(),
    ]);

  export const decode = (driver: Data.Reference.Reference) => (
    response: Runtime.ToType<typeof runtime>
  ): Event => ({
    ...Log.Event.Response.decode(driver)(response),
    ...Created.Response.decode(response),
  });
}
